module.exports = "/packs/images/homepage/facilities/library_mobile~4f4283acad0cf5221ce3eddde102ef66.jpg";